import { useContext } from 'react';
import { AllergensContext } from '../../providers/AllergensProvider';

export default function useAllergens() {
  return useContext(AllergensContext);
}
